/**
 * 支付弹窗组件
 * @author VenDream,chenqunfeng
 * @since 17/11/07
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { sendStat } from 'utils/common';
import Stat from '@fe/common/lib/stat';
import { createTamplateApp } from 'api/app';

import Dialog from '../dialog';
import './paydialog.less';

class PayDialog extends Component {
  static propTypes = {
    // 自定义样式
    style: PropTypes.object,
    // 是否模态
    modal: PropTypes.bool,
    // 支付状态(confirm | success | fail)
    status: PropTypes.string,
    // 关闭弹窗
    onClose: PropTypes.func,
    // 检查支付状态
    checkPayStatus: PropTypes.func,
    // 模版id
    templateId: PropTypes.string,
    // 用户id
    userId: PropTypes.string,
    // 企业id
    userOrganize: PropTypes.string,
    pfid: PropTypes.string,
    organizationId: PropTypes.string,
  };

  static defaultProps = {
    modal: true,
  };

  constructor() {
    super();

    this.tips = {
      confirm: {
        title: '支付提醒',
        message: '是否已支付成功？',
      },
      success: {
        title: '温馨提示',
        message:
          '支付成功，在模板预览页点击【去制作】按钮，或在编辑器内直接点击选择模板，即可使用已购买模板制作内容',
      },
      fail: {
        title: '温馨提示',
        message: '支付失败，请确定是否付款成功或联系客服',
      },
    };
  }

  getDialogContent() {
    const { status } = this.props;

    if (status in this.tips === false) {
      return null;
    }

    const title = this.tips[status].title;
    const message = this.tips[status].message;

    const btns =
      status === 'confirm' ? (
        <div className="btn-group">
          <div
            className="btn cancel-btn"
            onClick={this.checkPayStatus.bind(this, 'cancel')}>
            取消
          </div>
          <div
            className="btn confirm-btn"
            onClick={this.checkPayStatus.bind(this, 'confirm')}>
            确定
          </div>
        </div>
      ) : (
        <div className="btn-group">
          <div
            className="btn accept-btn"
            onClick={this.checkFailEndClick.bind(this)}>
            知道了
          </div>
        </div>
      );

    const content = (
      <div className="dialog-content">
        <div className="title">{title}</div>
        <div className="content">{message}</div>
        {btns}
      </div>
    );

    return content;
  }

  /**
   * 支付失败之后点击知道了
   */
  checkFailEndClick = async () => {
    const { onClose } = this.props;
    onClose();
    console.log('支付失败之后点击知道了----------', window.userStatus);
    sendStat('RP_STORE', '模版市场', '支付失败点击知道了', Stat.ACTION_CLICK, {
      id: 'web_espay_fail_click',
      os: window.browserInfo.os,
      browserVersion: window.browserInfo.browserVersion,
      userStatus: window.userStatus,
      url: window.location.href,
    });
  };

  // 检查支付状态
  checkPayStatus = async trigger => {
    const { onClose, checkPayStatus } = this.props;
    const result = checkPayStatus && (await checkPayStatus());
    onClose();

    if (trigger === 'confirm' && checkPayStatus) {
      if (result) {
        PayDialog.success();
      } else {
        PayDialog.fail();
      }
    }
  };

  // 购买完成创建作品
  createApp = async () => {
    const {
      templateId,
      userId,
      userOrganize,
      pfid,
      organizationId,
    } = this.props;
    await createTamplateApp({
      templateId,
      userId,
      userOrganize,
      pfid,
      organizationId,
    });
  };

  render() {
    const { style, modal, status } = this.props;
    const content = this.getDialogContent();

    return (
      <Dialog
        style={style}
        modal={modal}
        content={content}
        classname={classnames('pay-dialog', status)}
        closeBtn={true}
        onClose={() => {
          this.checkPayStatus('cancel');
        }}
      />
    );
  }
}

// 挂载弹窗到body下
function mount(props) {
  const div = document.createElement('div');
  document.body.appendChild(div);

  const dialog = React.createElement(PayDialog, {
    ...props,
    onClose: () => {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    },
  });

  ReactDOM.render(dialog, div);
}

// 卸载弹窗组件
function unmount() {
  const dialog = document.querySelector('.pay-dialog');

  if (dialog) {
    ReactDOM.unmountComponentAtNode(dialog);
    document.body.removeChild(dialog);
  }
}

PayDialog.confirm = props => mount({ ...props, status: 'confirm' });
PayDialog.success = props => mount({ ...props, status: 'success' });
PayDialog.fail = props => mount({ ...props, status: 'fail' });
PayDialog.close = unmount;

export default PayDialog;
